export default {
  install: 'Install',
  pause: 'Pause',
  pending: 'Pending',
  fail: 'Fail',
  installed: 'Open',
}